import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/src/auth.guard';
import { SharedUserContextGuard } from 'user-context';

const routes: Routes = [
  { path: '**', pathMatch: 'full', redirectTo: 'accounts' },
  { path: '', redirectTo: 'select-context', pathMatch: 'full' },
  {
    path: 'select-context',
    loadChildren: () => import('./views/bn-view-select-context/bn-view-select-context.module').then((m) => m.BnViewSelectContextModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'home',
    loadChildren: () => import('./views/bn-view-home/bn-view-home.module').then((m) => m.BnViewHomeModule),
    // canActivate: [SharedUserContextGuard],
  },
 
];
@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}